import Cookies from 'js-cookie'
import { appID } from '@/config/constant'

const TokenKey = 'Admin-Token'
const uidKey = 'uidKey'
const openidKey = 'openidKey'

export function getToken () {
  // return 'RongToken 9d67efc5d8764e9ca70b8c4c279c945a'
  // return null
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function setUid(uid) {
  return Cookies.set(uidKey, uid)
}

export function getUid () {
  // 会员的wx_scanid 的ID
  // return 430105 // linker 11
  // return 1
  return Cookies.get(uidKey)
}

export function removeUid() {
  return Cookies.remove(uidKey)
}

export function setOpenId(openid) {
  return Cookies.set(openidKey, openid)
}

export function getOpenId () {
  // return 'ob17kt_qBItR5Mu86vzUtkbwTw7g' //
  // return 'ov3vXshiuO7TWhgP7WLj4Z9mcIsQ' // 邓小姐 vip:13901 shop_id:230
  // return 'ov3vXsqw0MCYhEQQd1gPBaUcMJx4' // 何勇
  // return 'ov3vXsprYyO5DLXT9R9Tc-zxuGxY' // 曾先生     圆月汽车美容养护中心 230  13902
                                        // 民灯大师   圆月车会-1号店      22   58
  // return null;
  return Cookies.get(openidKey)
}

export function removeOpenId() {
  return Cookies.remove(openidKey)
}

export function baseAuthURL(backURL) {
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appID}&redirect_uri=${backURL}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
}

export function authURL(shopID) {
  // return wxBaseURL + `/nt/user/userbind/${shopID}/0/`
  return `/nt/user/userbind/${shopID}/0/`
}
